export default "__VITE_ASSET__C1a6a_xT__"